import { ReactElement, useRef, useCallback } from 'react';

import { FormHandles } from '@unform/core';
import { useHistory } from 'react-router-dom';
import { toast } from 'react-toastify';

import { Button, GoBackButton } from '~/components';
import { useLoading } from '~/hooks/loading';
import { IUserCadasterRequiredForm } from '~/models/User';
import ProfessionalService from '~/services/Professional';
import { handleYupValidationError, formatDate } from '~/utils';
import { UserSchema } from '~/utils/schemas/UserSchema';

import EditUserForm from '../EditUserForm';

import * as S from './styles';

function UserCadaster(): ReactElement {
  const { setLoading } = useLoading();
  const router = useHistory();
  const formRef = useRef<FormHandles>(null);

  const handleCancel = useCallback(() => {
    router.push('/users');
  }, [router]);

  const handleUserCadasterSubmit = useCallback(
    async (data: IUserCadasterRequiredForm) => {
      try {
        setLoading(true);

        formRef.current?.setErrors({});
        let formatedDate = '';

        if (data.birth_date) {
          formatedDate = formatDate(data.birth_date);
          const isValid = new Date(formatedDate).toString() !== 'Invalid Date';

          if (!isValid) throw new Error('Data de nascimento inválida');
        }
        await UserSchema.validate({ ...data, birth_date: formatedDate });

        const result = await ProfessionalService.createUser(data);
        if (result.status === 200) {
          toast.success('Usuário criado com sucesso!');
          setTimeout(() => router.push('/users'), 2000);
        } else {
          toast.error('Ocorreu um problema ao criar o usuário!');
        }

        setLoading(false);
      } catch (error) {
        setLoading(false);
        handleYupValidationError(formRef, error);
      }
    },
    [router],
  );

  return (
    <>
      <GoBackButton
        containerStyle={{ alignSelf: 'flex-start', paddingTop: '2.2rem' }}
      />
      <S.Container>
        <S.UsersCadasterHeader>
          <S.UserCadasterTitle>Cadastrar usuário</S.UserCadasterTitle>
        </S.UsersCadasterHeader>
        <EditUserForm
          handleSubmit={handleUserCadasterSubmit}
          formName="user-cadaster"
          formRef={formRef}
        />
        <S.UsersCadasterFooter>
          <Button
            form="user-cadaster"
            type="submit"
            textContent="Salvar"
            variant="black"
            size="small"
            extraStyles={{
              width: '200px',
            }}
          />
          <Button
            type="button"
            onClick={handleCancel}
            textContent="Cancelar"
            variant="red"
            size="small"
            extraStyles={{
              width: '200px',
            }}
          />
        </S.UsersCadasterFooter>
      </S.Container>
    </>
  );
}

export default UserCadaster;
